import React from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, Grid } from '@mui/material';
import FormContainer from '../../components/Form/FormContainer/FormContainer';
import FixedAssetsFormHeader from '../../components/Form/FormContainer/FormHeader';
import TextInput from '../../components/Form/FormInputs/TextInput/TextInput';
import FormPartial from '../../components/Form/FormContainer/FormPartial';
import DatacorLogoSpinner from '../../components/DatacorLogoSpinner/DatacorLogoSpinner';
import useRoleForm from './hooks/useRoleForm';
import SelectInput from '../../components/Form/FormInputs/SelectInput/SelectInput';

interface ParamTypes {
    id: string;
}

const RoleForm = () => {
    const { id } = useParams<ParamTypes>();
    const {
        fields,
        user,
        users,
        permissions,
        setValues,
        handleClose,
        handleFieldChange,
        handleUpdateRole,
        handleCreateRole,
        businessEntityOptions,
        isLoading,
        formMethods,
    } = useRoleForm(id);

    return (
        <Card>
            <CardHeader
                title={
                    (id ? fields.name : 'Create New Role') +
                    ` (${user?.businessEntity?.name})`
                }
            />
            {isLoading ? (
                <DatacorLogoSpinner />
            ) : (
                <CardContent>
                    <FormContainer
                        headerTitle={`Primary Information`}
                        onSubmit={() => formMethods.setIsFormSubmitted(true)}
                        headerComponent={
                            <FixedAssetsFormHeader
                                showOnDelete={false}
                                showOnSave={true}
                                onSave={async () => {
                                    if (!id) {
                                        await handleCreateRole();
                                    } else {
                                        await handleUpdateRole();
                                    }
                                }}
                                onDelete={handleClose}
                                onCancel={handleClose}
                                isEdit={!!id}
                            />
                        }>
                        <FormPartial>
                            <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <TextInput
                                        fullWidth
                                        label="Name"
                                        id="name"
                                        value={fields.name}
                                        onChange={handleFieldChange}
                                        formMethods={formMethods}
                                        required={true}
                                        maxLength={90}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <TextInput
                                        fullWidth
                                        label="Description"
                                        id="description"
                                        value={fields.description}
                                        onChange={handleFieldChange}
                                        formMethods={formMethods}
                                        maxLength={90}
                                    />
                                </Grid>
                                {/*
                                //TODO: determine if we want to keep this in the form or just have it be in the title
                                <Grid item xs={6}>
                                    <ExpandableDropdown
                                        valueSelected={(value) =>
                                            setValues({
                                                businessEntityId: value,
                                            })
                                        }
                                        defaultValue={fields.businessEntityId}
                                        items={businessEntityOptions}
                                        idKey="id"
                                        labelKey="name"
                                        label="Parent Business Entity"
                                        id="businessEntityId"
                                        formMethods={formMethods}
                                        required={true}
                                    />
                                </Grid>
                                */}
                                {!!id && (
                                    <>
                                        <Grid item xs={6}>
                                            <SelectInput
                                                fullWidth
                                                SelectProps={{ multiple: true }}
                                                label="Permissions"
                                                id="permissions"
                                                value={fields?.permissions}
                                                onChange={handleFieldChange}
                                                options={permissions}
                                                formMethods={formMethods}
                                            />
                                        </Grid>
                                        <Grid item xs={6}>
                                            <SelectInput
                                                fullWidth
                                                SelectProps={{ multiple: true }}
                                                label="Users"
                                                id="users"
                                                value={fields?.users}
                                                onChange={handleFieldChange}
                                                options={users}
                                                formMethods={formMethods}
                                            />
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </FormPartial>
                    </FormContainer>
                </CardContent>
            )}
        </Card>
    );
};

export default RoleForm;
